module.exports = __webpack_public_path__ + "static/media/toggle-button-dualtone-1.75e2f105.svg";